package com.daytimegaming.ourdailyfinances.data.network.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DashboardInviteDto(
    @SerialName("code") val code: String,
    @SerialName("created_at") val createdAt: String,
)

@Serializable
data class DashboardOwnerDto(
    @SerialName("user_id") val userId: String,
    @SerialName("email") val email: String? = null,
    @SerialName("first_name") val firstName: String? = null,
    @SerialName("last_name") val lastName: String? = null,
)

@Serializable
data class DashboardDto(
    @SerialName("dashboard_id") val dashboardId: String,
    @SerialName("name") val name: String,
    @SerialName("owner") val owner: DashboardOwnerDto,
    @SerialName("invites") val invites: List<DashboardInviteDto>? = null,
)

@Serializable
data class CreateDashboardResponseDto(
    @SerialName("dashboard_id") val dashboardId: String,
    @SerialName("name") val name: String,
    @SerialName("owner_user_id") val ownerUserId: String,
    @SerialName("invites") val invites: List<DashboardInviteDto>? = null,
)

@Serializable
data class DashboardListResponse(
    @SerialName("dashboards") val dashboards: List<DashboardDto>,
)

@Serializable
data class DashboardMemberDto(
    @SerialName("user_id") val userId: String,
    @SerialName("email") val email: String? = null,
    @SerialName("first_name") val firstName: String? = null,
    @SerialName("last_name") val lastName: String? = null,
    @SerialName("joined_at") val joinedAt: String,
)

@Serializable
data class DashboardAccountDto(
    @SerialName("account_id") val accountId: String,
    @SerialName("name") val name: String,
    @SerialName("official_name") val officialName: String? = null,
    @SerialName("type") val type: String,
    @SerialName("subtype") val subtype: String? = null,
    @SerialName("current_balance") val currentBalance: Double? = null,
    @SerialName("available_balance") val availableBalance: Double? = null,
    @SerialName("iso_currency_code") val isoCurrencyCode: String? = null,
    @SerialName("added_by_user_id") val addedByUserId: String,
    @SerialName("item_id") val itemId: String? = null,
    @SerialName("institution_name") val institutionName: String? = null,
    @SerialName("login_required") val loginRequired: Boolean = false,
    @SerialName("update_required") val updateRequired: Boolean = false,
    @SerialName("subscription_required") val subscriptionRequired: Boolean = false,
    @SerialName("nickname") val nickname: String? = null,
)

@Serializable
data class DashboardDetailDto(
    @SerialName("dashboard_id") val dashboardId: String,
    @SerialName("name") val name: String,
    @SerialName("owner_user_id") val ownerUserId: String? = null,
    @SerialName("owner") val owner: DashboardOwnerDto? = null,
    @SerialName("invites") val invites: List<DashboardInviteDto>? = null,
    @SerialName("members") val members: List<DashboardMemberDto>,
    @SerialName("accounts") val accounts: List<DashboardAccountDto>,
    @SerialName("transactions") val transactions: List<TransactionDto> = emptyList(),
    @SerialName("real_estate_holdings") val realEstateHoldings: List<RealEstateHoldingDto> = emptyList(),
    @SerialName("investments") val investments: InvestmentsDto? = null,
)

@Serializable
data class CreateDashboardRequest(
    @SerialName("name") val name: String,
)

@Serializable
data class AddDashboardAccountRequest(
    @SerialName("account_id") val accountId: String,
)

@Serializable
data class JoinDashboardRequest(
    @SerialName("invite_code") val inviteCode: String,
)

@Serializable
data class JoinDashboardResponse(
    @SerialName("dashboard_id") val dashboardId: String,
    @SerialName("name") val name: String,
)

@Serializable
data class MessageResponse(
    @SerialName("message") val message: String,
)

@Serializable
data class DashboardPreviewDto(
    @SerialName("dashboard_id") val dashboardId: String,
    @SerialName("name") val name: String,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("owner") val owner: DashboardOwnerDto,
    @SerialName("members") val members: List<DashboardOwnerDto>,
)
